import model from '../../model/Model';


export class NewsLoader {


	constructor() {
	}


	/**
	 * json取得処理
	 * 取得successCallBackへコールバック
	 * @param {string} url 取得jsonパス
	 * @param {*} successCallBack 取得後のコールバック
	 * @memberof NewsLoader
	 */
	public load(url:string, successCallBack):void {
		$.ajax({
			type: 'GET',
			url: url,
			// timeout: 10000,
			cache: false,
			dataType: 'json',
			// beforeSend: function(jqXHR) {
			// 	return true;
			// }
			// context: scope
		}).done(function(response, textStatus, jqXHR) {
			successCallBack( response );
		}).fail(function(jqXHR, textStatus, errorThrown ) {
			successCallBack( 'err' );
		}).always(function(data_or_jqXHR, textStatus, jqXHR_or_errorThrown) {

		});
	}
}
export default NewsLoader;


